import {
  ButtonNormalPrimaryMedium,
  ButtonWrapper,
} from '@ferreri/prever-component-lib';

import { useRedirectToContractDraft } from '../../utils/useRedirectToContractDraft';

type PlanDetailsAngeplusButtonProps = {
  planVersionId?: string | number;
};

export const PlanDetailsAngeplusButton = (
  props: PlanDetailsAngeplusButtonProps,
) => {
  const isInvalidId =
    props.planVersionId === undefined ||
    props.planVersionId === null ||
    props.planVersionId === '';

  const { redirectToContractDraft, isLoading } = useRedirectToContractDraft(
    props.planVersionId,
  );

  return (
    <ButtonWrapper
      onClick={redirectToContractDraft}
      isLoading={isLoading}
      isDisabled={isInvalidId || isLoading}
    >
      <ButtonNormalPrimaryMedium
        isLoading={isLoading}
        isDisabled={isInvalidId || isLoading}
      >
        Contratar plano
      </ButtonNormalPrimaryMedium>
    </ButtonWrapper>
  );
};
